// ============================================================
// Kvitto-lager — filnamns-parsning och kategorityper.
// ============================================================

export type ReceiptCategory = 'kundfakturor' | 'leverantorsfakturor' | 'utlagg'

export function parseFilename(name: string): {
  date?: string
  title?: string
  amount?: number
  currency?: string
} {
  const base = name.replace(/\.(pdf|png|jpg|jpeg)$/i, '')
  const normalized = base.replace(/\s*[\u2013\u2014]\s*/g, ' - ')
  const parts = normalized.split(/\s+-\s+/)
  if (parts.length < 2) return {}

  const result: ReturnType<typeof parseFilename> = {}

  const dateMatch = parts[0].trim().match(/^(\d{4}-\d{2}-\d{2})/)
  if (dateMatch) result.date = dateMatch[1]

  const lastPart = parts[parts.length - 1].trim()
  const currMatch = lastPart.match(/^([A-Z]{2,3})$/i)

  if (parts.length >= 4) {
    result.title = parts.slice(1, -2).join(' - ').trim()
    const amtStr = parts[parts.length - 2].replace(/\s/g, '').replace(',', '.')
    const amt = parseFloat(amtStr)
    if (!isNaN(amt)) result.amount = amt
    if (currMatch) result.currency = currMatch[1].toUpperCase()
  } else if (parts.length === 3) {
    const midPart = parts[1].trim()
    const tailPart = parts[2].trim()
    const tailAmt = parseFloat(tailPart.replace(/\s/g, '').replace(',', '.'))

    if (!isNaN(tailAmt)) {
      result.title = midPart
      result.amount = tailAmt
    } else if (currMatch) {
      const amtInTitle = midPart.match(/[\s\-](\d[\d\s]*[.,]?\d*)\s*$/)
      if (amtInTitle) {
        const amt = parseFloat(amtInTitle[1].replace(/\s/g, '').replace(',', '.'))
        if (!isNaN(amt)) {
          result.amount = amt
          result.title = midPart.slice(0, amtInTitle.index).replace(/[\s\-]+$/, '')
        } else {
          result.title = midPart
        }
      } else {
        result.title = midPart
      }
      result.currency = currMatch[1].toUpperCase()
    } else {
      result.title = midPart
    }
  } else if (parts.length === 2) {
    const tail = parts[1].trim()
    const amtCurrMatch = tail.match(/^(.+?)\s*[-\s]\s*(\d[\d\s]*[.,]?\d*)\s+([A-Z]{2,3})\s*$/i)
    if (amtCurrMatch) {
      result.title = amtCurrMatch[1].trim()
      const amt = parseFloat(amtCurrMatch[2].replace(/\s/g, '').replace(',', '.'))
      if (!isNaN(amt)) result.amount = amt
      result.currency = amtCurrMatch[3].toUpperCase()
    } else {
      result.title = tail
    }
  }
  return result
}

/** Fakturanummer from David's filename convention: `2026-017`, not a date (`2026-08-19`). */
export function invoiceNoFromFilename(name: string | undefined | null): string | null {
  if (!name) return null
  const m = name.match(/\b(20\d{2}-\d{3})\b/)
  return m ? m[1] : null
}

/** List label: `2026-017 · AI title` unless the number is already in the title. */
export function receiptListTitle(r: { title?: string | null; filename?: string | null }): string {
  const base = (r.title || r.filename || '').trim()
  const inv = invoiceNoFromFilename(r.filename)
  if (!inv) return base
  if (base.includes(inv)) return base
  return inv + ' \u00b7 ' + base
}
